import {
  CatalogFormFieldEntity,
  normalizeCatalogFormFieldEntity,
} from '../CatalogFormField';
import { FieldsCatalogEntityApi } from '../endpoints/form.fields_list';

import { FieldsCatalogEntity } from './entity';

/**
 * Нормализатор для каталога полей
 * @param raw
 * @param normalizerCallback - нормализует к выбранному формату
 */
export const normalizeFieldsCatalogData = <T>(
  raw: FieldsCatalogEntityApi,
  normalizerCallback: (elem: CatalogFormFieldEntity) => T
): FieldsCatalogEntity<T> => {
  const commonFields: Record<string, T[]> = {};

  Object.entries(raw.common_fields).forEach(([label, items]) => {
    commonFields[label] = items.map((item) =>
      normalizerCallback(normalizeCatalogFormFieldEntity(item))
    );
  });

  return {
    commonFields,
    myFields: raw.my_fields.map((item) =>
      normalizerCallback(normalizeCatalogFormFieldEntity(item))
    ),
  };
};
